if (!customElements.get('cubs-quick-add')) {
  customElements.define(
    'cubs-quick-add',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        // Prevent the drawer's quantity handler from treating
        // this variant selector as a cart quantity change.
        this.addEventListener('change', (event) => {
          event.stopPropagation();
          this.querySelector('[data-cubs-message]').textContent = '';
        });

        this.querySelector('[data-cubs-add]').addEventListener(
          'click',
          () => this.addProduct()
        );
      }

      async addProduct() {
        const button = this.querySelector('[data-cubs-add]');
        const selector = this.querySelector('[data-cubs-variant]');
        const message = this.querySelector('[data-cubs-message]');
        const drawer = document.querySelector('cart-drawer');

        if (button.disabled) return;

        message.textContent = '';

        if (!selector.value) {
          message.textContent = 'Please select a size / option.';
          selector.focus();
          return;
        }

        if (
          !drawer ||
          typeof drawer.getSectionsToRender !== 'function' ||
          typeof drawer.renderContents !== 'function'
        ) {
          message.textContent =
            'Quick add could not load. Please refresh the page.';
          return;
        }

        // Prevent simultaneous quick-add requests.
        if (drawer.dataset.cubsAdding === 'true') return;

        drawer.dataset.cubsAdding = 'true';
        button.disabled = true;
        button.textContent = 'Adding…';
        this.setAttribute('aria-busy', 'true');

        let added = false;

        try {
          const root = window.Shopify?.routes?.root || '/';
          const sections = drawer
            .getSectionsToRender()
            .map((section) => section.id);

          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: selector.value,
                  quantity: 1,
                },
              ],
              sections,
              sections_url: window.location.pathname,
            }),
          });

          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(
              result.description ||
                result.message ||
                'Unable to add this item. Please try again.'
            );
          }

          added = true;

                  // Only fetch again if the drawer HTML is missing
          // or does not contain the expected drawer.
          const hasDrawerMarkup = (html) => {
            if (!html) return false;

            return Boolean(
              new DOMParser()
                .parseFromString(html, 'text/html')
                .querySelector('#CartDrawer .drawer__inner')
            );
          };

          if (!hasDrawerMarkup(result.sections?.['cart-drawer'])) {
            const refreshURL = new URL(
              `${root}cart`,
              window.location.origin
            );

            refreshURL.searchParams.set(
              'sections',
              sections.join(',')
            );

            const refreshResponse = await fetch(refreshURL, {
              headers: {
                Accept: 'application/json',
              },
              cache: 'no-store',
            });

            if (!refreshResponse.ok) {
              throw new Error('Unable to refresh the drawer.');
            }

            const refreshedSections = await refreshResponse.json();

            result.sections = {
              ...(result.sections || {}),
              ...refreshedSections,
            };
          }

          drawer.renderContents(result);

          // Move keyboard focus into the refreshed drawer.
          requestAnimationFrame(() => {
            drawer.querySelector('.drawer__close')?.focus();
          });
        } catch (error) {
          message.textContent = added
            ? 'Item added. Refresh the page to see the updated cart.'
            : error.message ||
              'Connection interrupted. Check your cart before trying again.';

          // Avoid a duplicate add if the item was added but
          // the drawer could not refresh.
          if (added) {
            button.textContent = 'Added';
          }
        } finally {
          delete drawer.dataset.cubsAdding;
          this.removeAttribute('aria-busy');

          if (!added) {
            button.disabled = false;
            button.textContent = '+ Add to cart';
          }
        }
      }
    }
  );
}